import { Box, Divider, useTheme } from "@mui/material";
import React, { ReactElement, useCallback } from "react";

import CustomPopover from "@convin/components/custom_components/Popover/CustomPopover";
import { Label } from "@convin/components/custom_components/Typography/Label";
import TrailingSvg from "@convin/components/svg/TrailingSvg";

import useGlobalFiltersStateContext from "../../../../../../hooks/useGlobalFiltersStateContext";
import { StyledFilterBox, filterPopoverSx } from "../../../styles";
import { StaticDashboardFiltersType } from "@convin/type/Filters.model";
import AgentActivitySvg from "@convin/components/svg/OverallFiters/AgentActivitySvg";
import FilterListButton from "./FilterListButton";

export default function AgentActiveFilter(): ReactElement {
    const theme = useTheme();
    const { state, updateState } = useGlobalFiltersStateContext();

    const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = useCallback((): void => {
        setAnchorEl(null);
    }, []);

    const handleChange = (option: {
        id: StaticDashboardFiltersType["agent_activity"];
        value: string;
    }): void => {
        updateState({
            agent_activity: option.id,
            reps: [],
        });
        handleClose();
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const options: Array<{
        id: StaticDashboardFiltersType["agent_activity"];
        value: string;
    }> = [
        { id: "all", value: "All Agents" },
        { id: "active", value: "Active" },
        { id: "inactive", value: "Inactive" },
    ];

    return (
        <>
            <StyledFilterBox onClick={handleClick} aria-describedby={id}>
                <AgentActivitySvg />
                <Label
                    isEllipses
                    hasTooltip
                    colorType="white"
                    className="flex-1 font-semiBold"
                    variant="medium"
                >
                    {options.find(
                        (option) => option.id === state.agent_activity
                    )?.value ?? "All"}
                </Label>

                <Box {...(open && { className: "rotate-180" })}>
                    <TrailingSvg />
                </Box>
            </StyledFilterBox>
            <CustomPopover
                anchorEl={anchorEl}
                onClose={handleClose}
                sx={filterPopoverSx(theme)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Label colorType="666" variant="medium" sx={{ p: 1.5 }}>
                    Select Agent Status
                </Label>
                <Divider />
                <Box className="flex-1">
                    {options.map((option) => (
                        <FilterListButton
                            onClick={() => handleChange(option)}
                            key={option.id}
                        >
                            {option.value}
                        </FilterListButton>
                    ))}
                </Box>
            </CustomPopover>
        </>
    );
}
